import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { AppLayout } from '../layout/AppLayout';
import { LoginPage } from '../../pages/login/LoginPage';
import { TemplatesPage } from '../../pages/templates/TemplatesPage';
import { EmailTemplateCreatePage } from '../../pages/templates/EmailTemplateCreatePage';
import { CampaignCadencesPage } from '../../pages/campaign-cadences/CampaignCadencesPage';
import { ROUTES } from '../../shared/config/routes';
import { ROLES } from '../../features/auth/constants/roles';
import { ProtectedRoute } from './ProtectedRoute';
import { RoleRoute } from './RoleRoute';

const router = createBrowserRouter([
  { path: ROUTES.ROOT, element: <LoginPage /> },
  {
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: ROUTES.TEMPLATES, element: <TemplatesPage /> },
      {
        path: ROUTES.TEMPLATES_CREATE_EMAIL,
        element: (
          <RoleRoute allowedRoles={[ROLES.EDITOR]}>
            <EmailTemplateCreatePage />
          </RoleRoute>
        ),
      },
      {
        path: ROUTES.TEMPLATES_CREATE_SMS,
        element: (
          <RoleRoute allowedRoles={[ROLES.EDITOR]}>
            <EmailTemplateCreatePage />
          </RoleRoute>
        ),
      },
      {
        path: ROUTES.TEMPLATES_CREATE_MMS,
        element: (
          <RoleRoute allowedRoles={[ROLES.EDITOR]}>
            <EmailTemplateCreatePage />
          </RoleRoute>
        ),
      },
      {
        path: ROUTES.TEMPLATES_EDIT_EMAIL,
        element: (
          <RoleRoute allowedRoles={[ROLES.EDITOR]}>
            <EmailTemplateCreatePage />
          </RoleRoute>
        ),
      },
      {
        path: ROUTES.TEMPLATES_EDIT_SMS,
        element: (
          <RoleRoute allowedRoles={[ROLES.EDITOR]}>
            <EmailTemplateCreatePage />
          </RoleRoute>
        ),
      },
      {
        path: ROUTES.TEMPLATES_EDIT_MMS,
        element: (
          <RoleRoute allowedRoles={[ROLES.EDITOR]}>
            <EmailTemplateCreatePage />
          </RoleRoute>
        ),
      },
      { path: ROUTES.CAMPAIGNS, element: <CampaignCadencesPage /> },
    ],
  },
  { path: '*', element: <Navigate to={ROUTES.ROOT} replace /> },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
